import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'carbon-title-box',
  templateUrl: './carbon-title-box.component.html',
  styleUrls: ['./carbon-title-box.component.css']
})
export class CarbonTitleBoxComponent implements OnInit {

  @Input() title?: string;

  constructor() { }

  ngOnInit() {
  }

  get class(): string {
    return `bx--title-center`;
  }

}
